import { CenterContainer } from '@/components/CenterContainer/CenterContainer';
import { FC } from 'react';

import classes from './classes.module.css';

const Footer: FC = () => {
  return (
    <CenterContainer>
      <footer className={classes.footer}>
        <p className={classes.message}>
          Fait avec <span className={classes.heart}>❤️</span> pour Juliette et
          Lola
        </p>
      </footer>
    </CenterContainer>
  );
};

export default Footer;
